import { IMatchRunSettings } from ".";

export interface IMatchRunRequest {
    matchRunType: number,
    settings: IMatchRunSettings,
    diagnosticsData: IMatchRunDiagnostics
}

export interface IMatchRunDiagnostics {
    targetsPageMiracleMatches: number[],
    matchRunMiracleMatches: number[],
    targetsPagePriority12: number[],
    matchRunPriority12: number[],
    targetsPagePriority14: number[],
    matchRunPriority14: number[],
    targetsPagePriority15: number[],
    matchRunPriority15: number[],
    targetsPageLoadDateTime: string
}